import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import api from "../api";

function PaymentSuccess() {
  const [status, setStatus] = useState("loading");
  const [order, setOrder] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const orderId = searchParams.get("orderId");

  console.log("orderId", orderId);
  console.log("status", status);

  useEffect(() => {
    if (!orderId) {
      setStatus("error");
      return;
    }

    api
      .post("/verify", { orderId })
      .then((res) => {
        if (res.data?.body?.resultInfo?.resultStatus === "TXN_SUCCESS") {
          setStatus("success");
          setOrder(res.data.body);
        } else {
          setStatus("failed");
        }
      })
      .catch(() => setStatus("error"));
  }, [orderId]);

  return (
    <div style={styles.container}>
      {status === "loading" && <h2>Verifying Payment...</h2>}
      {status === "failed" && (
        <>
          {/* <h1 style={{ color: "green" }}>Payment Successful 🎉</h1>
          <p>Order ID: {orderId}</p>
          <p>Transaction ID: {order?.txnId}</p> */}
          <div style={styles.wrapper}>
            <div style={styles.card}>
              <h2 style={styles.title}>Payment Successful 🎉</h2>
              <p style={styles.text}>Your payment is completed.</p>

              {orderId && (
                <>
                  <p style={styles.small}>
                    <strong>Order ID: </strong>
                    {orderId}
                  </p>
                  <p style={styles.small}>
                    <strong>Transaction ID: </strong> {order?.txnId}
                  </p>
                </>
              )}

              <div style={styles.actions}>
                <button onClick={() => navigate("/")} style={styles.homeBtn}>
                  Go Home
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {status === "faileds" && (
        <>
          <h1 style={{ color: "orange" }}>Payment Failed</h1>
          <p>If amount was debited, it will be refunded automatically.</p>
        </>
      )}
      {status === "error" && (
        <>
          <h1 style={{ color: "red" }}>Invalid Payment</h1>
          <p>No valid order found.</p>
        </>
      )}
    </div>
  );
}

// const styles = {
//   container: {
//     minHeight: "50vh",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//   },
// };

const styles = {
  wrapper: {
    minHeight: "50vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9d893",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "420px",
    width: "100%",
  },
  title: {
    color: "#198754",
    marginBottom: "10px",
  },
  text: {
    color: "#555",
  },
  small: {
    fontSize: "14px",
    color: "#777",
    marginTop: "10px",
  },
  actions: {
    marginTop: "25px",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  },
  homeBtn: {
    flex: 1,
    background: "#636e72",
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
  },
};

export default PaymentSuccess;
